export default defineNuxtRouteMiddleware(async (to) => {
  // Franchise Opportunity Redirect
  if (to.path === '/franchise-opportunity' || to.path === '/franchise-opportunity/') {
    return navigateTo('https://springgreenfranchise.com', { external: true, redirectCode: 301 });
  }

  // Property Eval Redirect
  const evalPathMatch = to.path.match(/\/eval\/([^/]+)/i);
  if (evalPathMatch?.[1]) {
    return navigateTo({
      path: '/property-evaluation',
      query: {
        ...to.query,
        eval: evalPathMatch[1],
      },
    }, { redirectCode: 302 });
  }

  // October CMS Redirects
  const { $sg } = useNuxtApp();
  try {
    // Look up redirects by path only (query string is preserved separately below).
    // Encode to avoid leaking the page's query params into the CMS endpoint's query string.
    const data = await $sg.getOctoberData(`redirects/check?url=${encodeURIComponent(to.path)}`);
    // Normalize the redirect path by removing escape characters
    const normalizedPath: string | undefined = data?.url?.trim().replace(/\\\//g, '/');
    const redirectCode = data?.status_code ?? 301;
    // Redirect whenever the CMS-provided canonical path differs from the current
    // path. The comparison must be exact (NOT slash-insensitive): the CMS uses
    // trailing-slash canonicalization, so the only difference between `/foo` and
    // the canonical `/foo/` is the slash itself — stripping it would cancel out
    // the very redirect we need to perform. Exact equality is also its own
    // ping-pong guard: once we land on the canonical `/foo/`, the CMS returns an
    // empty response (no redirect), so the chain terminates.
    if (!!normalizedPath && normalizedPath !== to.path) {
      return navigateTo({ path: normalizedPath, query: to.query }, { redirectCode });
    }
  } catch {

  }
});
